import { FC } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { ButtonProps } from '@mui/material/Button';
import { SubmitButton, SubmitButtonProps } from 'app/components/elements/SubmitButton';
import { CircularProgress } from '@mui/material';

type CustomButtonProps = {
  label?: string;
  loading?: boolean;
  isCancel?: boolean;
  isDelete?: boolean;
  isCompleted?: boolean;
  styledLabel?: React.CSSProperties;
} & ButtonProps &
  SubmitButtonProps;

/**
 * @returns Element PrimaryButton
 */
export const ButtonCustom: FC<CustomButtonProps> = ({
  label,
  isDelete,
  loading,
  styledLabel,
  isCancel,
  isCompleted,
  ...props
}) => {
  return (
    <PrimaryButtonStyled
      isdelete={isDelete ? 'delete' : ''}
      isDisabled={props?.disabled ? 'disable' : ''}
      iscancel={isCancel ? 'cancel' : ''}
      iscompleted={isCompleted ? 'completed' : ''}
      {...props}>
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          {label && (
            <Typography style={styledLabel} fontSize={16} fontWeight={600}>
              {label}
            </Typography>
          )}
          {props.children}
        </>
      )}
    </PrimaryButtonStyled>
  );
};

const PrimaryButtonStyled = styled(SubmitButton)(
  ({
    iscancel,
    isdelete,
    iscompleted,
    isDisabled
  }: {
    iscancel?: string;
    isdelete?: string;
    iscompleted?: string;
    isDisabled?: string;
  }) => ({
    borderRadius: 10,
    textTransform: 'none',
    width: '100%',
    height: 56,
    background: isDisabled
      ? '#8d8d8d'
      : iscompleted
        ? '#4CAF50'
        : isdelete
          ? 'red'
          : iscancel
            ? 'white'
            : '#22374A',
    color: iscompleted ? 'white' : isdelete ? 'white' : iscancel ? '#22374A' : 'white',
    border: iscompleted
      ? '1px solid #4CAF50'
      : isdelete
        ? '1px solid red'
        : iscancel
          ? '1px solid #22374A'
          : 'none',
    '&:hover': {
      backgroundColor: iscompleted ? '#4CAF50' : isdelete ? 'red' : iscancel ? 'white' : '#22374A',
      opacity: 0.8
    }
  })
);
